import classNames from "classnames";
import React from "react";
import { useMediaQuery } from "../../../hooks";
import { Divider } from "../../divider";

import { Spacer } from "../../spacer";
import styles from "./unit_used_details.module.css";

interface UnitUsedDetailsProps {
  title: string;
  usedCount: number;
  description: string;
  isConfirmation?: boolean;
}

export function UnitUsedDetails({
  title,
  usedCount,
  description,
  isConfirmation,
}: UnitUsedDetailsProps) {
  const mq = useMediaQuery();
  return (
    <>
      {mq.device === "mobile" && <Divider />}
      <div
        className={classNames(styles.passedUsedComponent, {
          [styles.passedUsedComponentMobile]: mq.device === "mobile",
        })}
      >
        <div className={styles.passesUsedHeader}>
          <div>{title}</div>
          <div>{usedCount}</div>
        </div>
        <Spacer size={16} />
        <div className={styles.passesUsedDesc}>{description}</div>
      </div>
      {mq.device === "mobile" && isConfirmation && (
        <>
          <Spacer size={24} /> <Divider />
        </>
      )}
    </>
  );
}
